/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PeerComponent } from './peerComponent';


export interface ProviderComponentInventoryTree { 
    peer_components?: Array<PeerComponent>;
    related_components?: Array<string>;
}

